<template>
    <div>
        <v-container fluid grid-list-md >
            <v-layout justify-center>
                <h5 style="text-align:center">Las Lavanderias mas votadas</h5>
            </v-layout>
            <v-layout row wrap justify-center  >
                <v-flex xs10 sm7 md5 lg8 >
                    <v-list style="background: transparent">
                        <v-list-tile v-for="item in items" :key="item.title" avatar >
                            <v-list-tile-avatar>
                            <img :src="item.avatar">
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title v-html="item.title"></v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action style="margin-left:20px">

                                <v-btn flat icon color="indigo">
                                    <v-icon v-if="item.punctuation >=10">star</v-icon>
                                    <v-icon v-if="item.punctuation >=30">star</v-icon>
                                    <v-icon v-if="item.punctuation >=50">star</v-icon>
                                    <v-icon v-if="item.punctuation >=60">star</v-icon>
                                    <v-icon v-if="item.punctuation >=80">star</v-icon>
                                </v-btn>
                                
                            </v-list-tile-action>
                            <v-list-tile-action style="margin-left:20px;" v-if="session">
                                <v-menu :close-on-content-click="false">
                                    <v-btn icon slot="activator">
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>
                                    
                                    <v-list>
                                        <v-list-tile>
                                            <v-list-tile-content style="cursor: pointer">
                                                <v-list-tile-title class="fas fa-comment"> chat</v-list-tile-title>
                                            </v-list-tile-content>  
                                        </v-list-tile>  
                                        <v-list-tile>
                                            <v-list-tile-content style="cursor: pointer">
                                                <v-list-tile-title class="fas fa-location-arrow"> Geolocalización</v-list-tile-title>
                                            </v-list-tile-content>   
                                        </v-list-tile>  
                                    </v-list>
                                </v-menu>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

import initVue from '../../../helpers/initVue'

import {
    mapGetters
} from 'vuex'

  export default {
    data: () => ({
        items: [
          { title: 'S.O.S.', avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg', punctuation: 20 },
          { title: 'Servi Rap', avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg', punctuation: 40 },
          { title: 'Clean Cleaner', avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg', punctuation: 70 },
          { title: 'Mens', avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg', punctuation: 50 },
          { title: 'Burbujas', avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg', punctuation: 50 },
          { title: 'Mr. Jeff', avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg', punctuation: 80 }
        ],
        identity : null,
        token : null,
        session: false,

    }),

    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),

    mounted(){
        this.getidentity()
    },

    props:{
        
    },

    methods:{
        /*******************************************************
 * * Obteniendo la identidad para validar el token
 *******************************************************/
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)

        },
    }
  }
</script>